import { generateUuid } from './generateUuid';

export interface Generator {
  uuid: () => string;
  range: (start: number, end: number) => number[];
}

// Generates a sequence of integers from start to end, both inclusive.
const range = (start: number, end: number): number[] =>
  Array.from({ length: end - start + 1 }, (_, index) => start + index);

export const generate = (): Generator => ({
  uuid: generateUuid,
  range,
});
